import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import mistakes from './modules/mistakes';
import chat from './modules/chat';
import auth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { mistakes, chat, auth },
  state: {
    topic: '急性心肌梗死',
    summary: '急性心肌梗死是冠状动脉急性、持续性缺血缺氧所引起的心肌坏死。',
    loading: false,
    notes: [],
  },
  mutations: {
    setTopic(s, v) { s.topic = v; },
    setSummary(s, v) { s.summary = v; },
    setLoading(s, v) { s.loading = v; },
    setNotes(s, v) { s.notes = v; },
  },
  actions: {
    async generate({ commit }, topic) {
      commit('setLoading', true);
      try {
        const { data } = await axios.post('/api/notes/generate', { topic });
        commit('setTopic', data.topic);
        commit('setSummary', data.summary);
      } finally { commit('setLoading', false); }
    },
    async loadNotes({ commit }) {
      const { data } = await axios.get('/api/notes');
      commit('setNotes', data);
    },
  },
});
